<div [ngBusy]="{busy: busy, message: 'Loading type mappings...', backdrop: true, delay: 500, minDuration:50}"></div>
<div [ngBusy]="{busy: refreshBusy, message: 'Refreshing statistics...', backdrop: true, delay: 500, minDuration:50}">
</div>
<div class="row border-bottom-1" *ngIf=" action == crudActionTypes.LIST">
     <div class="col-lg-12">
          <div class="row">
               <div class="col-xl-6 col-lg-12">
                    <h2><i class="mio vat mr-1">developer_board</i>
                         <span>Manage type mappings</span>
                    </h2>
                    <p class="subtitle">In this
                         section you can configure and
                         create new types, defining fields types and indices settings.
                    </p>
               </div>
               <div class="col-xl-6 col-lg-12">
                    <div class="d-flex justify-content-end align-items-end">
                         <div class="input-group">
                              <input type="text" class="form-control shadow-small" [(ngModel)]="searchText"
                                   placeholder="Search for type mappings or fields..." />
                              <div class="input-group-append">
                                   <a class="input-group-text shadow-small  btn px-2">
                                        <i class="mio">search</i>
                                   </a>
                              </div>
                         </div>

                         <button class="btn btn-sm btn-text" style="min-width: 190px;"
                              (click)="openImportModal(importTypes.TYPE_MAPPING)"><i
                                   class="mio vat mr-1">vertical_align_bottom</i>
                              Import
                              configuration</button>
                         <button class="btn btn-sm btn-primary shadow-small" style="min-width: 200px;"
                              (click)="createTypeMapping();">Create type
                              mapping</button>
                    </div>
               </div>
          </div>
          <div class="row mb-3">
               <div class="col-lg-12">
                    <div class="d-flex justify-content-end align-items-end">
                         <label class="mr-2">Retention estimation period</label>
                         <ng-select [items]="availableTimePeriods" class="shadow-small mr-2" style="width: 140px;"
                              clearable="false" [(ngModel)]="selectedTimePeriod" bindLabel="name"></ng-select>
                         <button class="btn btn-info " (click)="refreshData()">Refresh data</button>
                    </div>
               </div>
          </div>
     </div>
</div>
<div class="row">
     <div class="col-lg-12">
          <ngb-alert *ngIf="errorMessage.hasError()" [dismissible]="true" [type]="'danger'"
               (close)="errorMessage.reset()">
               <div><strong>{{errorMessage.title}}</strong></div>
               <div>{{errorMessage.message}}</div>
          </ngb-alert>

          <ngb-alert [dismissible]=false [type]="'info'"
               *ngIf="typeMappings && typeMappings.length == 0  && action == crudActionTypes.LIST">
               No type mappings defined
          </ngb-alert>
          <table class="table table-hover table-outline table-striped"
               *ngIf="typeMappings && typeMappings.length > 0 && (action == crudActionTypes.LIST)">
               <thead>
                    <th style="width: 20px">
                         <div class="custom-control custom-checkbox mb-0">
                              <input type="checkbox" class="custom-control-input" name="selectAll" id="selectAll"
                                   type="checkbox" [checked]="exportList.length > 0"
                                   (change)="fillExportList($event, exportList, typeMappings, searchText, tableFilterPipe);"
                                   tooltip="Select all">
                              <label class="custom-control-label" for="selectAll"></label>
                         </div>
                    </th>
                    <!--
                    <th style="width: 20px"></th> 
               -->
                    <th>Name</th>
                    <th>Maximum events per index</th>
                    <th>Maximum index number</th>
                    <th>Events total</th>
                    <th>Events average size</th>
                    <th>Store size</th>
                    <th>Estimated store size</th>
                    <th>Estimated retention period</th>
                    <th class="text-right" style="width:    150px">
                         <ng-container *ngIf="!exportList || exportList.length == 0">
                              <div container="body" ngbDropdown class="d-inline-block no-arrow" [autoClose]="false">
                                   <a ngbDropdownToggle><i class="mio vat pt-0 px-2"
                                             [ngClass]="{'text-muted': !exportList || exportList.length == 0}">more_vert</i></a>
                              </div>
                         </ng-container>
                         <ng-container *ngIf="exportList && exportList.length > 0">
                              <div container="body" ngbDropdown class="d-inline-block no-arrow" [autoClose]="false">
                                   <a ngbDropdownToggle><i class="mio vat pointer pt-0 px-2"
                                             [ngClass]="{'text-muted': !exportList || exportList.length == 0}"
                                             ngbTooltip="Actions">more_vert</i></a>
                                   <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                                        <button
                                             (click)="exportObjects(exportList,importTypes[importTypes.TYPE_MAPPING],_managementService)"><i
                                                  class="mio vat mr-1">vertical_align_top</i> Export selected
                                             configurations</button>
                                        <div class="dropdown-divider"></div>
                                        <button class="btn-sm btn-text btn" ngbDropdownItem mwlConfirmationPopover
                                             popoverMessage="You are going to delete '{{exportList.length}}' Event Extractor Configurations. This process cannot be undone."
                                             confirmText="Delete" cancelText="Cancel" confirmButtonType="danger btn-sm"
                                             cancelButtonType="light btn-sm" closeOnOutsideClick="true"
                                             placement="bottom" (confirm)="deleteObjects(exportList)"><i
                                                  class="mio vat mr-2">close</i>
                                             Delete selected configurations</button>
                                   </div>
                              </div>
                         </ng-container>

                    </th>
               </thead>
               <tbody>
                    <tr *ngFor="let tm of typeMappings  |tableFilter: searchText; let i=index;">
                         <td>
                              <div class="custom-control custom-checkbox mb-0">
                                   <input type="checkbox" class="custom-control-input" name="selectedItem-{{tm.name}}"
                                        id="selectedItem-{{tm.name}}" type="checkbox"
                                        [checked]="exportList.indexOf(tm) >= 0"
                                        (change)="handleExportList(tm,exportList)" type="checkbox" [value]="tm">
                                   <label class="custom-control-label" for="selectedItem-{{tm.name}}"></label>
                              </div>
                         </td>
                         <!--
                         <td style="width: 20px;">
                              <span *ngIf="tm.injestionActive" class="badge badge-pill badge-success"
                                   ngbTooltip="Ingestion active">&nbsp;</span>
                              <span *ngIf="!tm.injestionActive" class="badge badge-pill badge-secondary"
                                   ngbTooltip="Ingestion inactive">&nbsp;</span>
                         </td>
                         -->
                         <td>
                              {{tm.name}}</td>
                         <td>
                              {{tm.rollMaxNumRecords | number}}
                         </td>
                         <td>
                              {{tm.rollKeepSize | number}}
                         </td>
                         <td>
                              <span *ngIf="typeMappingEstimation.get(tm.name)">{{typeMappingEstimation.get(tm.name).eventsTotal
                                   | shortNumber}}</span>
                         </td>
                         <td>
                              <span *ngIf="typeMappingEstimation.get(tm.name)">
                                   <span
                                        *ngIf="typeMappingEstimation.get(tm.name).eventsAverageSize && typeMappingEstimation.get(tm.name).eventsAverageSize != null">{{typeMappingEstimation.get(tm.name).eventsAverageSize
                                        | bytes }}</span>
                                   <span *ngIf="!typeMappingEstimation.get(tm.name).eventsAverageSize">
                                        n.d.
                                   </span>
                              </span>
                         </td>
                         <td>
                              <span *ngIf="typeMappingEstimation.get(tm.name)">{{typeMappingEstimation.get(tm.name).storeSize
                                   | bytes }}</span>
                         </td>
                         <td>
                              <span *ngIf="typeMappingEstimation.get(tm.name)">
                                   <i *ngIf="typeMappingEstimation.get(tm.name).estimateStoreSizeWarning"
                                        style="font-size: 1.4rem;" class="mio vam color-danger mr-1 p-2"
                                        ngbTooltip="The estimated store size is greater of available size of {{getAvaibleSpace(nodeStats)|bytes}}"
                                        [openDelay]="300" [closeDelay]="500">error</i>
                                   <span *ngIf="typeMappingEstimation.get(tm.name).estimatedStoreSize">
                                        {{typeMappingEstimation.get(tm.name).estimatedStoreSize | bytes }}
                                   </span>
                                   <span *ngIf="!typeMappingEstimation.get(tm.name).estimatedStoreSize">
                                        n.d.
                                   </span>

                              </span>
                         </td>
                         <td>

                              <span
                                   *ngIf="typeMappingEstimation.get(tm.name) && typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds">
                                   <span
                                        *ngIf="typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds && typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds != null">
                                        {{(typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds
                                        / selectedTimePeriod.value ) | number:'1.0-0' | shortNumber }}
                                        {{selectedTimePeriod.name}}
                                   </span>
                                   <span
                                        *ngIf="typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds == null || typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds === null || !typeMappingEstimation.get(tm.name).estimatedRetentionPeriodInSeconds">
                                        n.d.
                                   </span>
                              </span>
                         </td>
                         <td class="text-right px-0">
                              <button class="btn btn-xs py-1 px-2 btn-light" (click)="showDetails(tm)">Show
                                   details</button>
                              <div container="body" ngbDropdown class="d-inline-block no-arrow" [autoClose]="false">
                                   <a ngbDropdownToggle><i class="mio vat pointer pt-1 px-2"
                                             ngbTooltip="Actions">more_vert</i></a>
                                   <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                        <button ngbDropdownItem (click)="editTypeMapping(tm.name)"><i
                                                  class="mio vat mr-2">edit</i>Edit</button>
                                        <button *ngIf="tm.injestionActive" ngbDropdownItem
                                             (click)="handleIngestion(tm)"><i class="mio vat mr-1">stop</i>Stop
                                             ingestion</button>
                                        <button *ngIf="!tm.injestionActive" ngbDropdownItem
                                             (click)="handleIngestion(tm)"><i class="mio vat mr-2">play_arrow</i>Enable
                                             ingestion</button>

                                        <div class="dropdown-divider"></div>
                                        <button ngbDropdownItem
                                             (click)="exportObjects([tm],importTypes[importTypes.TYPE_MAPPING],_managementService)"><i
                                                  class="mio vat mr-1">vertical_align_top</i> Export
                                             configuration</button>

                                        <button ngbDropdownItem mwlConfirmationPopover
                                             popoverMessage="You are going to delete '{{tm.name}}' type mapping and all of its events. This process cannot be undone."
                                             confirmText="Delete" cancelText="Cancel" confirmButtonType="danger btn-sm"
                                             cancelButtonType="light btn-sm" closeOnOutsideClick="true"
                                             placement="bottom" (confirm)="deleteTypeMapping(tm.name)"><i
                                                  class="mio vat mr-2">close</i>
                                             Delete</button>
                                   </div>
                              </div>
                         </td>
                    </tr>
               </tbody>
          </table>


          <div *ngIf="action == crudActionTypes.CREATE || action == crudActionTypes.EDIT">
               <div class="row border-bottom-1">
                    <div class="col-lg-12">
                         <h2 *ngIf="action == crudActionTypes.CREATE"><i class="mio vat mr-1">developer_board</i>
                              <span>Create type mapping</span>
                         </h2>
                         <h2 *ngIf="action == crudActionTypes.EDIT"><i class="mio vat mr-1">developer_board</i>
                              <span>Edit type mapping</span>
                         </h2>
                    </div>
               </div>
               <form (ngSubmit)="saveTypeMapping(tmpTypeMapping)" class="row">
                    <div class="col-lg-6 col-md-12">
                         <div class="row">
                              <div class="form-group col-sm-12">
                                   <h5>Persistence settings</h5>
                              </div>
                              <div class="form-group col-sm-6">
                                   <label class="control-label">Name</label>
                                   <input type="text" [disabled]="action == crudActionTypes.EDIT"
                                        [(ngModel)]="tmpTypeMapping.name" class="form-control " name="name"
                                        placeholder="The type mapping name">
                              </div>
                              <!--
                              <div class="form-group col-sm-6">
                                   <div class="custom-control custom-checkbox">
                                        <label *ngIf="tmpTypeMapping.injestionActive" style="display: block;">Ingestion
                                             is
                                             active</label>
                                        <label *ngIf="!tmpTypeMapping.injestionActive" style="display: block;">Ingestion
                                             is not
                                             active</label>
                                        <button class="btn btn-sm btn-primary shadow-small"
                                             (click)="tmpTypeMapping.injestionActive = !tmpTypeMapping.injestionActive"
                                             *ngIf="!tmpTypeMapping.injestionActive">
                                             Enable ingestion</button>
                                        <button class="btn btn-sm btn-secondary shadow-small"
                                             (click)="tmpTypeMapping.injestionActive = !tmpTypeMapping.injestionActive"
                                             *ngIf="tmpTypeMapping.injestionActive">
                                             Disable ingestion</button>
                                   </div>
                              </div>
                              -->
                              <div class="form-group col-sm-6">
                                   <label class="control-label">Maximum events per index</label>
                                   <input type="text" [(ngModel)]="tmpTypeMapping.rollMaxNumRecords"
                                        class="form-control " name="rollMaxNumRecords"
                                        placeholder="Insert the maximum events per index">
                              </div>
                              <div class="form-group col-sm-6">
                                   <label class="control-label">Maximum index number</label>
                                   <input type="number" [(ngModel)]="tmpTypeMapping.rollKeepSize" class="form-control "
                                        name="rollKeepSize" placeholder="Insert the maximum index number">
                              </div>
                         </div>
                         <div class="form-group col-sm-12">
                              <h5>Fields mapping</h5>
                         </div>
                         <div class="col-lg-12">
                              <ngb-alert dismissible=false [type]="'info'"
                                   *ngIf="tmpTypeMapping && tmpTypeMapping.fields && tmpTypeMapping.fields.length == 0 && (action == crudActionTypes.CREATE ||  action == crudActionTypes.EDIT)">
                                   No fields mapping defined
                              </ngb-alert>
                              <table class="table table-hover table-outline table-striped"
                                   *ngIf="tmpTypeMapping && tmpTypeMapping.fields && tmpTypeMapping.fields.length > 0">
                                   <thead>
                                        <th style="width: 45%; max-width: 45%;">Name</th>
                                        <th style="width: 15%; max-width: 15%;">Type</th>
                                        <th style="width: 25%; max-width: 25%;">Format</th>
                                        <th style="width: 15%; max-width: 15%;"></th>
                                   </thead>
                                   <tbody>
                                        <tr *ngFor="let field of tmpTypeMapping.fields">
                                             <td>{{field.name}}</td>
                                             <td>
                                                  <span *ngIf="field.type == 'text' && field.hasKeyword"
                                                       class="badge type-keyword">Keyword</span>
                                                  <span *ngIf="field.type == 'text' && !field.hasKeyword"
                                                       class="badge type-string">String</span>
                                                  <span *ngIf="field.type == 'date'" class="badge type-date">Date</span>
                                                  <span *ngIf="field.type == 'long'"
                                                       class="badge type-number">Long</span>
                                                  <span *ngIf="field.type == 'float'"
                                                       class="badge type-number">Float</span>
                                                  <span *ngIf="field.type == 'ip'" class="badge type-ip">IP
                                                       Address</span>
                                             </td>
                                             <td>{{field.format || 'n.d.'}}</td>
                                             <td></td>
                                        </tr>
                                   </tbody>
                              </table>
                         </div>
                    </div>



                    <div class="col-lg-6 col-md-12">
                         <div class="row">
                              <div class="col-lg-12">
                                   <div class="form-group col-sm-12  d-flex justify-content-between">
                                        <h5>Add fields mapping</h5>
                                   </div>
                                   <table class="table">
                                        <tbody>
                                             <tr>
                                                  <td style="width: 45%; max-width: 45%;">
                                                       <ng-select class="type-selector type-selector-name"
                                                            [items]="fieldMappings" [closeOnSelect]="true"
                                                            placeholder="Enter the field name" name="fieldMappings"
                                                            bindLabel="name" [addTag]="true" [(ngModel)]="tmpField">
                                                       </ng-select>
                                                  </td>
                                                  <td style="width: 15%; max-width: 15%;">
                                                       <ng-select class="typeSelector" [items]="fieldTypes"
                                                            [closeOnSelect]="true" placeholder="Select field type"
                                                            name="types" [(ngModel)]="tmpField.type"
                                                            (change)="handleTypeChange($event, tmpField)"
                                                            bindValue="type" bindLabel="name">
                                                            <ng-template ng-label-tmp let-item="item">
                                                                 <span class="badge type-number"
                                                                      *ngIf="item.name === 'Long'">Long</span>
                                                                      <span class="badge type-number"
                                                                      *ngIf="item.name === 'Float'">Float</span>
                                                                 <span class="badge type-ip"
                                                                      *ngIf="item.name === 'IP Address'">IP
                                                                      Address</span>
                                                                 <span class="badge type-date"
                                                                      *ngIf="item.name === 'Date'">Date</span>
                                                                 <span class="badge type-keyword"
                                                                      *ngIf="item.name === 'Keyword'">Keyword</span>
                                                                 <span class="badge type-string"
                                                                      *ngIf="item.name === 'String'">String</span>
                                                            </ng-template>
                                                            <ng-template ng-option-tmp let-item="item">
                                                                 <span class="badge type-number"
                                                                      *ngIf="item.name === 'Long'">Long</span>
                                                                      <span class="badge type-number"
                                                                      *ngIf="item.name === 'Float'">Float</span>
                                                                 <span class="badge type-ip"
                                                                      *ngIf="item.name === 'IP Address'">IP
                                                                      Address</span>
                                                                 <span class="badge type-date"
                                                                      *ngIf="item.name === 'Date'">Date</span>
                                                                 <span class="badge type-keyword"
                                                                      *ngIf="item.name === 'Keyword'">Keyword</span>
                                                                 <span class="badge type-string"
                                                                      *ngIf="item.name === 'String'">String</span>
                                                            </ng-template>
                                                       </ng-select>
                                                  </td>
                                                  <td style="width: 25%; max-width: 25%;"
                                                       *ngIf="tmpField.type === null || tmpField.type !== 'date'"></td>
                                                  <td style="width: 25%; max-width: 25%;"
                                                       *ngIf="tmpField.type != null && tmpField.type === 'date' ">
                                                       <ng-select class="typeSelector" [items]="dateFormats"
                                                            [closeOnSelect]="true" placeholder="Insert date format"
                                                            name="dateFormats" [(ngModel)]="tmpField.format"
                                                            [addTag]="true" bindLabel="name"></ng-select>
                                                  </td>
                                                  <td style="width: 15%; max-width: 15%;" class="text-right">
                                                       <button class="btn btn-sm btn-primary shadow-small" type="button"
                                                            [disabled]="(tmpField.name || tmpField.name == null || tmpField.name == '') && (!tmpField.type || tmpField.type == null)"
                                                            (click)="addFieldMapping(tmpField)">Add
                                                            field</button>
                                                  </td>
                                             </tr>

                                        </tbody>
                                   </table>


                                   <table class="table table-hover table-outline table-striped"
                                        *ngIf="tmpFieldMappings && tmpFieldMappings.length > 0">
                                        <thead>
                                             <th style="width: 45%; max-width: 45%;">Name</th>
                                             <th style="width: 15%; max-width: 15%;">Type</th>
                                             <th style="width: 25%; max-width: 25%;">Format</th>
                                             <th style="width: 15%; max-width: 15%;"></th>
                                        </thead>
                                        <tbody>
                                             <tr *ngFor="let field of tmpFieldMappings; let idx = index;">
                                                  <td>{{field.name}}</td>
                                                  <td>
                                                       <span class="badge type-number"
                                                            *ngIf="field.type === 'long'">Long</span>
                                                            <span class="badge type-number"
                                                            *ngIf="field.type === 'float'">Float</span>
                                                       <span class="badge type-ip" *ngIf="field.type === 'ip'">IP
                                                            Address</span>
                                                       <span class="badge type-date"
                                                            *ngIf="field.type === 'date'">Date</span>
                                                       <span class="badge type-keyword"
                                                            *ngIf="field.type === 'text' && field.hasKeyword">Keyword</span>
                                                       <span class="badge type-string"
                                                            *ngIf="field.type === 'text' && !field.hasKeyword">String</span>
                                                  </td>
                                                  <td>
                                                       {{field.format || 'n.d.'}}
                                                  </td>
                                                  <td class="text-right">
                                                       <button class="btn btn-sm btn-light"
                                                            (click)="removeField(field)">Delete</button>
                                                  </td>
                                             </tr>
                                        </tbody>
                                   </table>
                              </div>
                         </div>
                    </div>
               </form>
               <div class="col-lg-12 text-right">
                    <button class="btn btn-light mr-1 "
                         (click)="action = crudActionTypes.LIST; errorMessage.reset();">Cancel</button>
                    <button class="btn btn-primary" (click)="saveTypeMapping(tmpTypeMapping)">Save</button>
               </div>
          </div>
          <div *ngIf="action == crudActionTypes.DETAILS">
               <div class="row">
                    <div class="col-lg-6">
                         <h2><i class="mio vat mr-1">developer_board</i>
                              <span i18n>Type '{{tmpTypeMapping.name}}' overview</span>
                         </h2>
                         <p class="subtitle"
                              *ngIf="action == crudActionTypes.DETAILS && tmpTypeMapping && tmpTypeMapping.name">
                              <strong>Maximum events per index:
                              </strong>{{tmpTypeMapping.rollMaxNumRecords | shortNumber }} - <strong>Maximum index
                                   number:
                              </strong>{{tmpTypeMapping.rollKeepSize | shortNumber}}
                         </p>
                    </div>
                    <div class="col-lg-6">
                         <div class="d-flex justify-content-end align-items-end">
                              <button class="btn btn-light mr "
                                   (click)="action = crudActionTypes.LIST; errorMessage.reset();">Back</button>
                         </div>
                    </div>
               </div>
               <div class="row mb-3">
                    <div class="col-lg-12">
                         <div class="d-flex justify-content-end align-items-end">
                              <label class="mr-2">Retention estimation period</label>
                              <ng-select [items]="availableTimePeriods" style="width: 140px;" class="shadow-small mr-2"
                                   clearable="false" [(ngModel)]="selectedTimePeriod" bindLabel="name"></ng-select>
                              <button class="btn btn-info" (click)="refreshData()">Refresh data</button>
                         </div>
                    </div>
               </div>
               <table class="table table-hover table-outline table-striped"
                    *ngIf="tmpTypeMapping && (typeMappingOverview && typeMappingOverview.length > 0)">
                    <thead>
                         <th>Timestamp field</th>
                         <th>Total events per type</th>
                         <th>Events count</th>
                         <th>From time</th>
                         <th>To time</th>
                         <th>Number of indices</th>
                         <th>Store size</th>
                         <th *ngIf="selectedTimePeriod.name == 'Weeks'">Events per week</th>
                         <th *ngIf="selectedTimePeriod.name == 'Days'">Events per day</th>
                         <th *ngIf="selectedTimePeriod.name == 'Hours'">Events per hour</th>
                         <th *ngIf="selectedTimePeriod.name == 'Minutes'">Events per minute</th>
                         <th *ngIf="selectedTimePeriod.name == 'Seconds'">Events per second</th>

                         <th></th>
                    </thead>
                    <tbody>
                         <ng-container *ngFor="let tmo of typeMappingOverview">
                              <tr *ngIf="tmo.name == tmpTypeMapping.name"
                                   [ngClass]="{'table-active': tmo.timestampField == selectedTimestampField && tmo.name == tmpTypeMapping.name}">
                                   <td>{{tmo.timestampField}}</td>
                                   <td>{{tmo.eventsTotal | number: '1.0-0'}}</td>
                                   <td>{{tmo.eventsCount | number: '1.0-0'}}</td>
                                   <td>
                                        <span *ngIf="tmo.minTime > 0">
                                             {{tmo.minTime | date: user.options['dateFormat'] : user.options['timeZone']
                                             != 'Client default' ? user.options['timeZone'] : ''}}
                                        </span>
                                        <span *ngIf="tmo.minTime == 0">n.d.</span>
                                   </td>
                                   <td>
                                        <span *ngIf="tmo.maxTime > 0">
                                             {{tmo.maxTime | date: user.options['dateFormat'] : user.options['timeZone']
                                             != 'Client default' ? user.options['timeZone'] : ''}}
                                        </span>
                                        <span *ngIf="tmo.maxTime == 0">n.d.</span>
                                   </td>
                                   <td>{{tmo.indicesOverview.length | number}}</td>
                                   <td>{{tmo.storeSize | bytes}}</td>
                                   <td *ngIf="selectedTimePeriod.name == 'Weeks' ">
                                        {{tmo.eventsPerWeek| number:'1.0-0' }}
                                   </td>
                                   <td *ngIf="selectedTimePeriod.name == 'Days' ">
                                        {{tmo.eventsPerDay| number:'1.0-0' }}
                                   </td>
                                   <td *ngIf="selectedTimePeriod.name == 'Hours'">
                                        {{tmo.eventsPerHour| number:'1.0-0' }}
                                   </td>
                                   <td *ngIf="selectedTimePeriod.name == 'Minutes'">
                                        {{tmo.eventsPerMin| number:'1.0-1' }}
                                   </td>
                                   <td *ngIf="selectedTimePeriod.name == 'Seconds'">
                                        {{tmo.eventsPerSec| number:'1.0-1' }}
                                   </td>

                                   <td style="width: 160px;">
                                        <button class="btn btn-sm btn-light"
                                             (click)="showTypeOverview(tmo.timestampField)">Type
                                             overview</button>
                                   </td>
                              </tr>
                         </ng-container>
                    </tbody>
               </table>
               <ng-container *ngIf="selectedTimestampField !== null">
                    <ng-container *ngFor="let tmo of typeMappingOverview">
                         <ng-container
                              *ngIf="tmo.name == tmpTypeMapping.name && tmo.timestampField == selectedTimestampField">
                              <div class="row mb-4">
                                   <div class="col-lg-12">
                                        <h3><i class="mio vat mr-1">schedule</i> Timestamp field
                                             '{{tmo.timestampField}}'</h3>
                                        <p class="subtitle"><strong>From:
                                             </strong>{{tmo.minTime | date: user.options['dateFormat'] :
                                             user.options['timeZone'] != 'Client default' ? user.options['timeZone'] :
                                             ''}}
                                             <strong>To:</strong>{{tmo.maxTime | date: user.options['dateFormat'] :
                                             user.options['timeZone'] != 'Client default' ? user.options['timeZone'] :
                                             ''}}
                                        </p>
                                   </div>

                                   <div class="col-lg-2 col-md-4">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsCount | number:'1.0-0'
                                                       }}</span>
                                                  <span class="counter-label">Events count</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.indicesOverview.length |
                                                       number}}</span>
                                                  <span class="counter-label">Number of indices</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="typeMappingEstimation.get(tmo.name)">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number"
                                                       *ngIf="!typeMappingEstimation.get(tmo.name).eventsAverageSize">n.d.</span>
                                                  <span class="counter-number"
                                                       *ngIf="typeMappingEstimation.get(tmo.name).eventsAverageSize">{{typeMappingEstimation.get(tmo.name).eventsAverageSize
                                                       | bytes}}</span>
                                                  <span class="counter-label">Event average size</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="typeMappingEstimation.get(tmo.name)">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number"
                                                       *ngIf="!typeMappingEstimation.get(tmo.name).estimatedStoreSize">n.d.</span>
                                                  <span class="counter-number"
                                                       *ngIf="typeMappingEstimation.get(tmo.name).estimatedStoreSize"><i
                                                            *ngIf="typeMappingEstimation.get(tmo.name).estimateStoreSizeWarning"
                                                            style="font-size: 1.4rem;"
                                                            class="mio vam color-danger mr-1 p-2"
                                                            ngbTooltip="The estimated store size is greater of available size"
                                                            [openDelay]="300"
                                                            [closeDelay]="500">error</i>{{typeMappingEstimation.get(tmo.name).estimatedStoreSize
                                                       | bytes}}</span>
                                                  <span class="counter-label">Estimated store size</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="selectedTimePeriod.name == 'Weeks'">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsPerWeek |number:'1.0-0'
                                                       }}</span>
                                                  <span class="counter-label">Events per week</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="selectedTimePeriod.name == 'Days'">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsPerDay | number:'1.0-0'
                                                       }}</span>
                                                  <span class="counter-label">Events per day</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="selectedTimePeriod.name == 'Hours'">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsPerHour | number:'1.0-0'
                                                       }}</span>
                                                  <span class="counter-label">Events per hour</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="selectedTimePeriod.name == 'Minutes'">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsPerMin | number:'1.0-1'
                                                       }}</span>
                                                  <span class="counter-label">Events per minute</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="selectedTimePeriod.name == 'Seconds'">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number">{{tmo.eventsPerSec | number:'1.0-1'
                                                       }}</span>
                                                  <span class="counter-label">Events per second</span>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-2 col-md-4" *ngIf="typeMappingEstimation.get(tmo.name)">
                                        <div class="card counter-widget">
                                             <div class="card-body">
                                                  <span class="counter-number"
                                                       *ngIf="typeMappingEstimation.get(tmo.name).estimatedRetentionPeriodInSeconds">
                                                       {{(typeMappingEstimation.get(tmo.name).estimatedRetentionPeriodInSeconds
                                                       / selectedTimePeriod.value) | number:'1.0-0' }}
                                                       {{selectedTimePeriod.name}}</span>
                                                  <span class="counter-label">Estimated retention period</span>
                                             </div>
                                        </div>
                                   </div>

                                   <div class="col-lg-12 mt-4"
                                        *ngIf="chartOptions && chartOptions.xAxis && chartOptions.xAxis.categories && chartOptions.xAxis.categories.length > 0">
                                        <div class="card">
                                             <div class="card-body">
                                                  <div [ng2-highcharts]="chartOptions"></div>
                                             </div>
                                        </div>
                                   </div>
                                   <div class="col-lg-12 mt-4">
                                        <h3 class="float-left mb-4">Indices overview</h3>

                                        <button class="btn btn-sm btn-danger float-right mb-4" mwlConfirmationPopover
                                             popoverMessage="You are going to close all indices except the writing one."
                                             confirmText="Proceed" cancelText="Cancel" confirmButtonType="danger btn-sm"
                                             cancelButtonType="light btn-sm" closeOnOutsideClick="true"
                                             placement="bottom" (confirm)="closeAllIndices(tmpTypeMapping.name)"
                                             [disabled]="indicesCloseableList[tmpTypeMapping.name] == 1 ">Close all
                                             indices</button>
                                        <button class="btn btn-sm btn-success float-right mb-4 mr-1"
                                             mwlConfirmationPopover
                                             popoverMessage="You are going to open all the closed indices."
                                             confirmText="Proceed" cancelText="Cancel" confirmButtonType="danger btn-sm"
                                             cancelButtonType="light btn-sm" closeOnOutsideClick="true"
                                             placement="bottom" (confirm)="openAllIndices(tmpTypeMapping.name)"
                                             [disabled]="indicesCloseableList[tmpTypeMapping.name] == tmo.indicesOverview.length">Open
                                             all
                                             closed indices</button>

                                        <table class="table table-hover table-outline table-striped"
                                             *ngIf="tmo.indicesOverview && tmo.indicesOverview.length > 0">
                                             <thead>
                                                  <th>Status</th>
                                                  <th>Index name</th>
                                                  <th>From time</th>
                                                  <th>To time</th>
                                                  <th>Events total</th>
                                                  <th>Store size</th>
                                                  <th></th>
                                             </thead>
                                             <tbody>
                                                  <ng-container *ngFor="let index of tmo.indicesOverview">

                                                       <tr>
                                                            <td style="width: 50px;">
                                                                 <span class="badge badge-success text-center px-2 mr-2"
                                                                      *ngIf="index.status == 'open'">Open</span>
                                                                 <span class="badge badge-secondary text-center px-2 mr-2"
                                                                      *ngIf="index.status == 'close'">Closed</span>
                                                                 <span class="badge badge-danger text-center px-2 mr-2"
                                                                      *ngIf="index.status == 'error'">Error</span>
                                                            </td>
                                                            <td>{{index.name}}</td>
                                                            <td>
                                                                 <span *ngIf="index.minTime > 0">
                                                                      {{index.minTime | date: user.options['dateFormat']
                                                                      : user.options['timeZone'] != 'Client default' ?
                                                                      user.options['timeZone'] : ''}}
                                                                 </span>
                                                                 <span *ngIf="index.minTime == 0">n.d.</span>
                                                            </td>
                                                            <td>
                                                                 <span *ngIf="index.maxTime > 0">
                                                                      {{index.maxTime | date: user.options['dateFormat']
                                                                      : user.options['timeZone'] != 'Client default' ?
                                                                      user.options['timeZone'] : ''}}
                                                                 </span>
                                                                 <span *ngIf="index.maxTime == 0">n.d.</span>
                                                            </td>
                                                            <td>{{index.eventsTotal | number: '1.0-0'}}</td>
                                                            <td>{{index.storeSize | bytes }}</td>
                                                            <td style="width: 160px;" class="text-right"><button
                                                                      *ngIf="index.status == 'close'" type="button"
                                                                      class="btn btn-sm btn-light"
                                                                      (click)="openIndex(index.name)">Open
                                                                      index</button></td>
                                                       </tr>
                                                       <tr *ngIf="index.status === 'error'">
                                                            <td [colSpan]="7">
                                                                 <ngb-alert [dismissible]="false" [type]="'danger'">
                                                                      <div>{{index.message}}</div>
                                                                 </ngb-alert>
                                                            </td>
                                                       </tr>
                                                  </ng-container>
                                             </tbody>
                                        </table>
                                   </div>
                              </div>
                         </ng-container>
                    </ng-container>
               </ng-container>
               <div class="col-lg-12 text-right">
                    <button class="btn btn-light"
                         (click)="action = crudActionTypes.LIST; errorMessage.reset();">Back</button>
               </div>
          </div>
     </div>
</div>